<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JajlDt/tc-custom/9781466846265.jpg?1732049223707" alt="This image is the cover for the book No Place to Die, Mike Lockyer Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">No Place to Die, Mike Lockyer Novels
      </h1>
      <p class="bookDescription body article font2">
        <p>Jane Bennett, senior Detective Sergeant for the murder squad at her London police precinct, is having a terrible day. Her boss, Detective Inspector Mike Lockyer, has just returned to work after two weeks on "leave," though Jane knows it was really more like a suspension. He's still shaken by the loss of a victim in their last murder case, and Jane is still stung that Lockyer didn't trust her enough to confide in her about the case before it was too late.<br/><br/>But neither of them has the luxury of time to dwell on past grievances. Jane has just received a phone call from a good friend saying that her husband Mark Leech, a retired policeman, has disappeared. When Jane finds dramatic blood splatters in the laundry room, she knows Mark is seriously injured at best, and they don't have any time to waste. And then the body of a young girl is discovered in a tomb under a London greenway, and police resources are stretched even thinner…until it starts to look like the two cases might be related.<br/><br/><i>No Place to Die</i> is another spine-tingling mystery with complex, three-dimensional characters from suspense master Clare Donoghue.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Clare Donoghue
      </h2>
      
      <p class="authorDescription body article"><P>After ten years in London, working for a City law firm, CLARE DONOGHUE moved back to her home town in Somerset to undertake an MA in creative writing at Bath Spa University. In 2011 the initial chapters of <I>Never Look Back</I>, previously entitled <I>Chasing Shadows</I>, were longlisted for the CWA Debut Dagger award. <I>No Place to Die</I> is Clare's second novel.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a061779